import { Box, ITheme, Typography, useTheme } from '@mui/material';
import React from 'react';
import { PortfolioDetailsFundItem } from '../../../../models/Portfolio';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { AUTHENTICATED_ROUTES } from '../../../../resources/routes-constants';
import { Utilities } from '../../../../utility/utils';

export interface IFundsAllocationLineGraphProps {
    funds: PortfolioDetailsFundItem[];
    target: number;
}

const FundsAllocationLineGraph: React.FC<IFundsAllocationLineGraphProps> = ({ funds, target }) => {

    const theme = useTheme() as ITheme;
    const colors = Utilities.shuffleArray(Object.keys(theme.palette.leo).filter(k => k.indexOf("color")!== -1).map(k => (theme.palette.leo as any)[k]));
    const breakCount = Math.ceil(funds.length/2);
    const { i18n } = useTranslation();
    const navigate = useNavigate();

    const itemClick = (fund: PortfolioDetailsFundItem) => {
        navigate(AUTHENTICATED_ROUTES.LIBRARYOFFUNDS_ITEM_ROUTE.replace(":id", `${fund.id}`));
    }

    const renderItem = (fund: PortfolioDetailsFundItem, color: string, isLast: boolean): JSX.Element => {
        return <Box display={"flex"} width={"100%"} gap={"5px"} alignItems={"center"} padding={"14px 0"} borderBottom={isLast ? undefined : `solid 1px ${theme.palette.primary.main}`} key={`fund-${fund.id}`}>
            <Box bgcolor={color} width={"14px"} borderRadius={"50%"} height={"14px"}></Box>
            <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"400"} flexBasis={"100px"} flexGrow={1.5} sx={{ cursor: "pointer"}} onClick={() => itemClick(fund)}>{fund.name}</Typography>
            <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"400"} textAlign={"center"}>{Math.round(100 * fund.proportion)}%</Typography>
            <Typography fontSize={"16px"} lineHeight={"19.5px"} fontWeight={"700"} flexBasis={"50px"} flexGrow={1} textAlign={"right"}>{`€${Math.round(fund.proportion * target).toLocaleString(i18n.language)}`}</Typography>
        </Box>;
    }
    return <>
        <Box display={"flex"} height={"9px"} width={"100%"} borderRadius={"10px"} overflow={"hidden"} gap={"4px"} bgcolor={theme.palette.leo.type[25]}>
            {funds.map((f, index) => <Box key={`fund-${f.name}`} flexGrow={f.proportion * target} height={"100%"} bgcolor={colors[index % colors.length]}></Box>)}
        </Box>
        <Box display={"flex"} width={"100%"} gap={"35px"}>
            <Box display={"flex"} flexDirection={"column"} flexGrow={1} flexBasis={"50%"}>
                {funds.slice(0, breakCount).map((f, index, array) => renderItem(f, colors[index % colors.length], index === array.length-1))}
            </Box>
            <Box display={"flex"} flexDirection={"column"} flexGrow={1} flexBasis={"50%"}>
                {funds.slice(breakCount).map((f, index, array) => renderItem(f, colors[(index+breakCount)% colors.length], index === array.length-1))}
            </Box>
        </Box>
    </>;
}

export default FundsAllocationLineGraph;